<template>
  <div class="smsAuth">
    <Header propsTitle="회원가입" />
    <div class="container height-fix">
      <SMSAuthStep01Form v-if="smsAuthStep === 1" :smsAuthStep="smsAuthStep" :userData="userData" :smsBtnDisabled="smsBtnDisabled" @startSmsAuthSend="startSmsAuthSend"/>
      <SMSAuthStep02Form v-if="smsAuthStep === 2" :smsAuthStep="smsAuthStep" :userData="userData"  :smsRetry="smsRetry" @startSmsAuthSend="startSmsAuthSend" @clickBack="smsAuthStep--" @validAuthCode="onValidAuthCode"/>
      <CommonDialog ref="refCommonDialog" @clickOk="clickPopupOk" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "../../commonComp/WS-Header.vue";
import Stepper from "./agree/Stepper.vue";
import SMSAuthStep01Form from "./userForm/SMSAuthStep01Form.vue";
import SMSAuthStep02Form from "./userForm/SMSAuthStep02Form.vue";
import CommonDialog from "@/_zplabZPT/commonComp/dialog/CommonDialog.vue";
const modelService = require("@/utils/dataModel.js");
const rulesService = require("@/utils/rules.js");

export default {
  components: {
    Header,
    Stepper,
    SMSAuthStep01Form,
    SMSAuthStep02Form,
    CommonDialog,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      smsAuthStep: 1,
      smsBtnDisabled: false,
      smsRetry:{
        countdown: 120, // 120초부터 시작
        countdownInterval: null,
        retry: false,
        smsRetryTimer: null, // 타이머 객체
      },
      reqData: {
        endpoint: "smsDigitAuth",
        checkType: "id",
        loginId: "",
      },
      smsAuth:{
        digit: "",
        issueTime: null
      }

    };
  },
  computed: {
    ...mapGetters(["isDev", "isAuthorized"]),
  },
  methods: {
    startSmsAuthSend() {
      this.reqData.loginId = this.userData.loginId;
      this.reqData.queryMethod = "POST";

      this.smsRetry.retry = false;
      this.smsRetry.countdown = 120;

      // 기존 타이머 정리
      if (this.smsRetry.smsRetryTimer) clearTimeout(this.smsRetry.smsRetryTimer);
      if (this.smsRetry.countdownInterval) clearInterval(this.smsRetry.countdownInterval);

      // 2분 뒤 retry 활성화
      this.smsRetry.smsRetryTimer = setTimeout(() => {
        this.smsRetry.retry = true;
        this.smsRetry.countdown = 0;
        clearInterval(this.smsRetry.countdownInterval);
      }, 120 * 1000);

      // 매초마다 countdown 감소
      this.smsRetry.countdownInterval = setInterval(() => {
        if (this.smsRetry.countdown > 0) {
          this.smsRetry.countdown--;
        }
      }, 1000);

      this.sendSmsAuth(); // SMS 전송
    },

    sendSmsAuth() {
      const $h = this.$helper;

      // 전송버튼 비활성화 (문자 재전송 방지)
      this.smsBtnDisabled = true;

      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;

        if (res.returnCode === 'notOK') {
          this.smsBtnDisabled = false
          this.isActionMode = "EXIST_USER";
          this.$refs.refCommonDialog.open(res.message);
          return;
        }

        // 인증번호 발송 완료 후
        if (res.returnCode === 'OK') {
          if(this.isDev) alert('SMS발송완료 : ' + res.authDigit)
          this.smsAuth.digit = res.authDigit
          this.smsAuth.issueTime = new Date(res.issueTime)
          // 화면 변경
          setTimeout(() => {
            this.smsAuthStep = 2;
            this.smsBtnDisabled = false
          }, 100 * 1);
        }
      });
    },

    onValidAuthCode(userDigit) {
      const $h = this.$helper;

      const now = new Date()
      const expireTime = (now.getTime() - this.smsAuth.issueTime.getTime()) / 1000

      if (expireTime > 5 * 60){
        $h.showTostMessage("", "인증시간이 초과되었습니다. 새로운 인증번호로 재인증해주세요.", "error");
        // setTimeout(() => {
        //   this.startSmsAuthSend()
        // }, 1000 * 1);
        return;
      }

      if (this.smsAuth.digit === userDigit) {
        this.smsAuthStep = 3;
        this.$emit('clickNext')
      }else{
        this.isActionMode = "INVALID_AUTH";
        this.$refs.refCommonDialog.open("인증번호를 다시 확인해주세요");
        return;
      }
    },

    clickPopupOk() {
      if (this.isActionMode === "EXIST_USER") {
        this.userData.loginId = ""
      }
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
  beforeDestroy() {
    if (this.smsRetry.smsRetryTimer) clearTimeout(this.smsRetryTimer);
    if (this.smsRetry.countdownInterval) clearInterval(this.smsRetry.countdownInterval);
  },
};
</script>

